import React, {FC, useContext, useState, useEffect} from 'react';
import {CustomFieldInput} from "../../../../../../components/UI/AntCustom/CustomFieldInput";
import {CommonFormMessages} from "../../../../../../intl/commonMessages/CommonFormMessages";
import {Col, Radio, Tooltip, Row, DatePicker, Select} from "antd";
import {defineMessages, useIntl} from "react-intl";
import {FlyHourPriceContext} from "./context/FlyHourPriceContextProvider";
import {
  FlyHourPriceCalculatorSettingTypeEnum, FlyHourPriceDefaultCategoryEnum,
  FlyHourPriceDefaultSettingTypeEnum, FlyHourPriceDefaultSubcategoryEnum
} from "./types/flyHourPriceSettingEnums";
import {
  IFlyHourCalculatorCategory,
  IFlyHourCalculatorSettingType,
  IFlyHourCalculatorSubCategory
} from "../../../../../../store/reducers/fleetReducer/fleetReducerTypes";
import styled from "styled-components";
import RemoveIcon from "../../../../../../media/icons/remove_field.svg?react";
import {useFlyPriceCategorySetter} from "./hooks/useFlyPriceCategorySetter";
import {CustomInputNumber} from "../../../../../../components/UI/AntCustom/CustomInputNumber";
import {Rule} from "antd/lib/form";
import moment, {Moment} from "moment";
import {FONTS} from "../../../../../../utils/constans/styles/fonts";

const RadioButtonsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  gap: 36px;
  width: 266px;
  height: 24px;
  margin-bottom: 12px;
`;

const RadioButtonItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  gap: 8px;
  height: 24px;
`;

const RadioButtonCircle = styled.div<{checked: boolean}>`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0px;
  width: 24px;
  height: 24px;
  background: ${props => props.checked ? '#0C50FF' : '#FFFFFF'};
  border: ${props => props.checked ? 'none' : '1.5px solid #313745'};
  border-radius: 100px;
  cursor: pointer;
`;

const RadioButtonInner = styled.div`
  width: 12px;
  height: 12px;
  background: #FFFFFF;
  border-radius: 100px;
`;

const RadioButtonLabel = styled.span`
  font-family: ${FONTS.TEXT_REGULAR_INTER};
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 120%;
  display: flex;
  align-items: center;
  color: #000000;
`;

const CoefficientInputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 4px;
  width: 100%;
`;

const CoefficientInputContainer = styled.div<{isSeasonal?: boolean}>`
  box-sizing: border-box;
  position: relative;
  width: 100%;
  height: 47px;
  background: ${props => props.isSeasonal ? '#FFFFFF' : '#F9F9F9'};
  border: 1px solid #D9DAD9;
  border-radius: 5px;
  display: flex;
  align-items: center;
  padding: 0 10px;
`;

const CoefficientInput = styled.input`
  flex: 1;
  border: none;
  background: transparent;
  font-family: ${FONTS.TEXT_REGULAR_INTER};
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 120%;
  color: #000000;
  outline: none;
  
  &::placeholder {
    color: #808080;
  }
`;

const CoefficientPercent = styled.span`
  font-family: ${FONTS.TEXT_REGULAR_INTER};
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 120%;
  color: #6B6B6B;
  margin-left: 8px;
`;

const CoefficientDescription = styled.div`
  font-family: ${FONTS.TEXT_REGULAR_INTER};
  font-style: normal;
  font-weight: 400;
  font-size: 10px;
  line-height: 120%;
  color: #757575;
  margin-top: 4px;
`;

const RemoveButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  width: fit-content;
  flex-shrink: 0;
`;

const LabelWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 8px;
  
  > div:first-child {
    flex: 1;
  }
`;

const MarginBlockWrapper = styled.div`
  background: #D9D9D9;
  border: 1px solid #FFFFFF;
  border-radius: 8px;
  padding: 20px;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
  font-family: 'Inter', sans-serif;
  
  .ant-row.ant-form-item {
    margin: 0;
  }
`;

const MarginBlockTitle = styled.div`
  font-family: 'Inter', sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 120%;
  color: #000000;
`;

const MarginBlockContent = styled.div`
  display: flex;
  gap: 24px;
  align-items: stretch;
`;

const MarginBlockColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: flex-start;
  justify-content: space-between;
  flex: 0.9;
  min-width: 0;
`;

const MarginBlockColumnDuration = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  height: inherit;
  justify-content: flex-end;
  flex: 1;
  min-width: 0;
`;

const MarginBlockColumnUrgency = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: flex-start;
  flex: 1;
  min-width: 0;
`;

const MarginBlockFieldWrapperDuration = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  height: 100%;
  justify-content: flex-end;
`;

const MarginBlockRadioGroup = styled.div`
  display: flex;
  gap: 24px;
  align-items: center;
`;

const MarginBlockRadioItem = styled.div`
  display: flex;
  gap: 5px;
  align-items: center;
  cursor: pointer;
`;

const MarginBlockRadioCircle = styled.div<{checked: boolean}>`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: ${props => props.checked ? 'none' : '1.5px solid #313745'};
  background: ${props => props.checked ? '#0C50FF' : '#FFFFFF'};
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
`;

const MarginBlockRadioInner = styled.div<{checked: boolean}>`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: ${props => props.checked ? '#FFFFFF' : 'transparent'};
`;

const MarginBlockRadioLabel = styled.span`
  font-family: 'Inter', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 120%;
  color: #000000;
`;

const MarginBlockFieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`;

const MarginBlockFieldLabel = styled.div`
  font-family: 'Inter', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 120%;
  color: #000000;
`;

const MarginBlockInputWrapper = styled.div`
  position: relative;
  width: 100%;
`;

const MarginBlockSelectWrapper = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;
  
  .ant-row.ant-form-item {
    margin: 0;
  }
`;

const MarginBlockDescription = styled.div`
  font-family: 'Inter';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 120%;
  color: #757575;
  margin-top: 8px;
`;

const MarginBlockFooterDescription = styled.div`
  font-family: 'Inter', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 120%;
  color: #757575;
  text-align: right;
  width: calc(30% * 1.3);
  max-width: calc(30% * 1.3);
`;


const FlyHourPriceCalculatorFieldMessages = defineMessages({
  percent: {
    id: "flyHourPriceCalculatorField.percent",
    defaultMessage: "Percent",
  },
  fix: {
    id: "flyHourPriceCalculatorField.fix",
    defaultMessage: "Fixed amount",
  },
  fromHours: {
    id: "flyHourPriceCalculator.fromHours",
    defaultMessage: "From Hours",
  },
  toHours: {
    id: "flyHourPriceCalculator.toHours",
    defaultMessage: "To Hours (leave empty for infinity)",
  },
  dateFrom: {
    id: "flyHourPriceCalculator.dateFrom",
    defaultMessage: "Date From",
  },
  dateTo: {
    id: "flyHourPriceCalculator.dateTo",
    defaultMessage: "Date To",
  },
  fuelGallonsPerHour: {
    id: "flyHourPriceCalculator.fuelGallonsPerHour",
    defaultMessage: "Fuel Gallons Per Hour",
  },
})

// Simplified parser: removes spaces and filters out letters (InputNumber handles precision and formatting)
const createCalculatorParser = () => {
  return (value: string | undefined) => {
    if (!value) return undefined as unknown as number;
    // Remove spaces and filter out letters (keep only numbers, decimal point, and minus sign)
    const cleaned = value.replace(/\s/g, '').replace(/[^0-9.\-]/g, '');
    // Limit to 8 characters total
    const limited = cleaned.length > 8 ? cleaned.slice(0, 8) : cleaned;
    // Return as number (InputNumber expects number from parser)
    return limited ? Number(limited) as unknown as number : undefined as unknown as number;
  };
};

// Simplified keydown handler: prevents letters and enforces 8 character limit
const createCalculatorKeyDownHandler = () => {
  return (e: React.KeyboardEvent<HTMLInputElement>) => {
    const target = e.target as HTMLInputElement;
    const currentValue = target.value?.replace(/\s/g, '') || '';
    
    // Prevent letters (InputNumber handles decimal precision automatically)
    if (e.key.length === 1 && !(e.ctrlKey || e.metaKey || e.altKey)) {
      if (!/[0-9.\-]/.test(e.key) && 
          !['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Tab', 'Enter'].includes(e.key)) {
        e.preventDefault();
        return;
      }
      
      // Prevent input if already 8 characters (excluding control keys)
      if (currentValue.length >= 8 && 
          !['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight'].includes(e.key)) {
        e.preventDefault();
        return;
      }
    }
  };
};

// Simplified onChange handler: filters letters and enforces 8 character limit
const handleCalculatorInputChange = (value: string, updateFn: (value: number | undefined) => void) => {
  // Remove letters and limit to 8 characters
  const cleaned = value.replace(/[^0-9.\-]/g, '').slice(0, 8);
  const numValue = cleaned ? parseFloat(cleaned) : undefined;
  updateFn(numValue);
};

// Simplified paste handler
const createCalculatorPasteHandler = (updateFn: (value: number | undefined) => void) => {
  return (e: React.ClipboardEvent<HTMLInputElement>) => {
    e.preventDefault();
    handleCalculatorInputChange(e.clipboardData.getData('text'), updateFn);
  };
};

interface IFlyHourPriceCalculatorField {
  category: IFlyHourCalculatorCategory;
  subcategory: IFlyHourCalculatorSubCategory;
  settingType: IFlyHourCalculatorSettingType;
}

export const FlyHourPriceCalculatorField: FC<IFlyHourPriceCalculatorField> = ({category, subcategory, settingType}) => {
  const intl = useIntl();
  const {currency, isMarginTaxesDisabled} = useContext(FlyHourPriceContext);
  const categorySetter = useFlyPriceCategorySetter(category.keyName);
  const defaultType = settingType.setting.specificType ? settingType.setting.specificType : settingType.type;
  const [selectedType, setSelectedType] = useState<FlyHourPriceCalculatorSettingTypeEnum>(defaultType);
  const [isPeriodEditing, setIsPeriodEditing] = useState(false);

  const onTypeChange = (type: FlyHourPriceCalculatorSettingTypeEnum) => {
    setSelectedType(type);

    if (categorySetter) {
      categorySetter(c => {
        return {
          ...c, subcategories: c.subcategories.map(sc => {
            if (sc.keyName !== subcategory.keyName)
              return sc;
            return {
              ...sc, settingTypes: sc.settingTypes.map(st => {
                if (st.keyName !== settingType.keyName)
                  return st;
                return {
                  ...st,
                  setting: {
                    id: settingType.setting.id,
                    value: settingType.setting.value,
                    specificType: type
                  }
                }
              })
            }
          })
        }
      })
    }
  }

  const removeField = () => {
    if (categorySetter) {
      categorySetter(c => {
        return {
          ...c, subcategories: c.subcategories.map(sc => {
            if (sc.keyName !== subcategory.keyName)
              return sc;
            return {...sc, settingTypes: sc.settingTypes.filter(st => st.keyName !== settingType.keyName)}
          })
        }
      })
    }
  }

  const rules: Rule[] = category.keyName !== FlyHourPriceDefaultCategoryEnum.CATEGORY_COEFFICIENT ? [{
    min: 1,
    type: "number",
    message: intl.formatMessage(CommonFormMessages.ruleMustBePositive)
  }] : [];

  const isFieldDisabled = settingType.keyName === FlyHourPriceDefaultSettingTypeEnum.PARAMETER_MARGIN_TAXES && isMarginTaxesDisabled;
  const spanDependingOnSubcategory = [
    FlyHourPriceDefaultSubcategoryEnum.SUB_CATEGORY_CONSTANT_DEFAULT,
    FlyHourPriceDefaultSubcategoryEnum.SUB_CATEGORY_CHANGEABLE_DEFAULT,
    FlyHourPriceDefaultSubcategoryEnum.SUB_CATEGORY_MARGIN_TAXES,
    FlyHourPriceDefaultSubcategoryEnum.SUB_CATEGORY_MARGIN_COMPANY_MARGIN,
    FlyHourPriceDefaultSubcategoryEnum.SUB_CATEGORY_COEFFICIENT_DEFAULT,
  ].includes(subcategory.keyName as FlyHourPriceDefaultSubcategoryEnum) ? 12 : 6;

  // Проверяем, является ли это блоком маржи с диапазонами часов
  const isMarginBlock = settingType.keyName === FlyHourPriceDefaultSettingTypeEnum.PARAMETER_MARGIN_AMOUNT 
    || settingType.keyName.startsWith(FlyHourPriceDefaultSettingTypeEnum.PARAMETER_MARGIN_AMOUNT + '_');
  
  // Проверяем, является ли это сезонным коэффициентом
  const isSeasonalCoefficient = settingType.keyName === FlyHourPriceDefaultSettingTypeEnum.PARAMETER_COEFFICIENT_HIGH_SEASON 
    || settingType.keyName === FlyHourPriceDefaultSettingTypeEnum.PARAMETER_COEFFICIENT_LOW_DATES;
  
  // Проверяем, является ли это полем топлива
  const isFuelField = settingType.keyName === FlyHourPriceDefaultSettingTypeEnum.PARAMETER_CHANGEABLE_FUEL_GALLONS_PER_HOUR;

  // Рендер налогов
  const isTaxesField = settingType.keyName === FlyHourPriceDefaultSettingTypeEnum.PARAMETER_MARGIN_TAXES;

  // Радио-кнопки для коэффициентов
  const isCoefficientCategory = category.keyName === FlyHourPriceDefaultCategoryEnum.CATEGORY_COEFFICIENT;
  const isCoefficientField = isCoefficientCategory && !isFuelField && !isMarginBlock && !isTaxesField;
  
  const radioButtons = isCoefficientField ? (
    <RadioButtonsWrapper>
      <RadioButtonItem onClick={() => onTypeChange(FlyHourPriceCalculatorSettingTypeEnum.PERCENT)}>
        <RadioButtonCircle checked={selectedType === FlyHourPriceCalculatorSettingTypeEnum.PERCENT}>
          {selectedType === FlyHourPriceCalculatorSettingTypeEnum.PERCENT && <RadioButtonInner />}
        </RadioButtonCircle>
        <RadioButtonLabel>{intl.formatMessage(FlyHourPriceCalculatorFieldMessages.percent)}</RadioButtonLabel>
      </RadioButtonItem>
      <RadioButtonItem onClick={() => onTypeChange(FlyHourPriceCalculatorSettingTypeEnum.FLAT)}>
        <RadioButtonCircle checked={selectedType === FlyHourPriceCalculatorSettingTypeEnum.FLAT}>
          {selectedType === FlyHourPriceCalculatorSettingTypeEnum.FLAT && <RadioButtonInner />}
        </RadioButtonCircle>
        <RadioButtonLabel>{intl.formatMessage(FlyHourPriceCalculatorFieldMessages.fix)}</RadioButtonLabel>
      </RadioButtonItem>
    </RadioButtonsWrapper>
  ) : undefined;

  const updateSettingField = (fieldName: string, value: any) => {
    if (categorySetter) {
      categorySetter(c => {
        return {
          ...c, subcategories: c.subcategories.map(sc => {
            if (sc.keyName !== subcategory.keyName)
              return sc;
            return {
              ...sc, settingTypes: sc.settingTypes.map(st => {
                if (st.keyName !== settingType.keyName)
                  return st;
                return {
                  ...st,
                  setting: {
                    ...st.setting,
                    [fieldName]: value
                  }
                }
              })
            }
          })
        }
      })
    }
  };

  // Рендер блока маржи с диапазонами часов
  if (isMarginBlock) {
    // Находим поле urgency в той же subcategory
    const urgencyField = subcategory.settingTypes.find(
      st => st.keyName === FlyHourPriceDefaultSettingTypeEnum.PARAMETER_MARGIN_URGENCY_DISCOUNT
    );
    const urgencyType = urgencyField?.setting.specificType ?? urgencyField?.type ?? FlyHourPriceCalculatorSettingTypeEnum.PERCENT;
    
    // Получаем индекс блока для заголовка
    const blockIndex = subcategory.settingTypes
      .filter(st => st.keyName === FlyHourPriceDefaultSettingTypeEnum.PARAMETER_MARGIN_AMOUNT 
        || st.keyName.startsWith(FlyHourPriceDefaultSettingTypeEnum.PARAMETER_MARGIN_AMOUNT + '_'))
      .findIndex(st => st.keyName === settingType.keyName) + 1;

    return (
      <Col span={24}>
        <MarginBlockWrapper>
          <MarginBlockTitle>
            {intl.formatMessage({id: "flyHourPriceCalculator.marginBlock", defaultMessage: "Margin, block {index}"}, {index: blockIndex})}
          </MarginBlockTitle>
          <MarginBlockContent>
            {/* Левая колонка: Margin Amount */}
            <MarginBlockColumn>
              <MarginBlockRadioGroup>
                <MarginBlockRadioItem onClick={() => onTypeChange(FlyHourPriceCalculatorSettingTypeEnum.PERCENT)}>
                  <MarginBlockRadioCircle checked={selectedType === FlyHourPriceCalculatorSettingTypeEnum.PERCENT}>
                    <MarginBlockRadioInner checked={selectedType === FlyHourPriceCalculatorSettingTypeEnum.PERCENT} />
                  </MarginBlockRadioCircle>
                  <MarginBlockRadioLabel>{intl.formatMessage(FlyHourPriceCalculatorFieldMessages.percent)}</MarginBlockRadioLabel>
                </MarginBlockRadioItem>
                <MarginBlockRadioItem onClick={() => onTypeChange(FlyHourPriceCalculatorSettingTypeEnum.FLAT)}>
                  <MarginBlockRadioCircle checked={selectedType === FlyHourPriceCalculatorSettingTypeEnum.FLAT}>
                    <MarginBlockRadioInner checked={selectedType === FlyHourPriceCalculatorSettingTypeEnum.FLAT} />
                  </MarginBlockRadioCircle>
                  <MarginBlockRadioLabel>{intl.formatMessage(FlyHourPriceCalculatorFieldMessages.fix)}</MarginBlockRadioLabel>
                </MarginBlockRadioItem>
              </MarginBlockRadioGroup>
              <MarginBlockFieldWrapper>
                <MarginBlockFieldLabel>
                  {intl.formatMessage({id: "flyHourPriceCalculator.marginAmount", defaultMessage: "Margin amount"})}
                </MarginBlockFieldLabel>
                <MarginBlockInputWrapper>
                  <CustomFieldInput
                    name={settingType.keyName}
                    rules={rules}
                  >
                    <CustomInputNumber
                      disabled={isFieldDisabled}
                      controls={false}
                      placeholder={intl.formatMessage({id: "flyHourPriceCalculator.enterValue", defaultMessage: "Введите значение"})}
                      addonAfter={selectedType === FlyHourPriceCalculatorSettingTypeEnum.FLAT ? currency?.name : '%'}
                      style={{width: "100%", background: "#fff", height: "47px"}}
                      onChange={(value) => updateSettingField('value', value)}
                      value={settingType.setting.value}
                      precision={2}
                      parser={createCalculatorParser()}
                      onKeyDown={createCalculatorKeyDownHandler()}
                    />
                  </CustomFieldInput>
                </MarginBlockInputWrapper>
              </MarginBlockFieldWrapper>
            </MarginBlockColumn>

            {/* Средняя колонка: Apply for flights by duration */}
            <MarginBlockColumnDuration>
              <MarginBlockFieldWrapperDuration>
                <MarginBlockFieldLabel>
                  {intl.formatMessage({id: "flyHourPriceCalculator.applyForFlightsByDuration", defaultMessage: "Apply for flights by duration"})}
                </MarginBlockFieldLabel>
                <MarginBlockSelectWrapper>
                  <div style={{display: 'flex', alignItems: 'center'}}>
              <CustomFieldInput
                name={`${settingType.keyName}_fromHours`}
                rules={[{min: 0, type: "number", message: intl.formatMessage(CommonFormMessages.ruleMustBePositive)}]}
              >
                <CustomInputNumber
                  controls={false}
                        placeholder="1"
                  min={0}
                        style={{width: "120px", background: "#fff", height: "47px"}}
                  onChange={(value) => updateSettingField('fromHours', value)}
                        value={settingType.setting.fromHours ?? 1}
                  addonBefore=">"
                  addonAfter="h"
                />
              </CustomFieldInput>
                  </div>
                  <span style={{fontSize: 18, color: '#000000', display: 'flex', alignItems: 'center', justifyContent: 'center', height: '47px'}}>—</span>
                  <div style={{display: 'flex', alignItems: 'center'}}>
              <CustomFieldInput
                name={`${settingType.keyName}_toHours`}
              >
                <CustomInputNumber
                  controls={false}
                        placeholder={intl.formatMessage({id: "flyHourPriceCalculator.noLimit", defaultMessage: "No limit"})}
                  min={0}
                        style={{width: "92px", background: "#fff", height: "47px"}}
                  onChange={(value) => updateSettingField('toHours', value || undefined)}
                  value={settingType.setting.toHours}
                  addonAfter="h"
                />
              </CustomFieldInput>
                  </div>
                </MarginBlockSelectWrapper>
              </MarginBlockFieldWrapperDuration>
            </MarginBlockColumnDuration>

            {/* Правая колонка: Departure urgency */}
            {urgencyField && (
              <MarginBlockColumnUrgency>
                <MarginBlockRadioGroup>
                  <MarginBlockRadioItem onClick={() => {
                    if (categorySetter) {
                      categorySetter(c => {
                        return {
                          ...c, subcategories: c.subcategories.map(sc => {
                            if (sc.keyName !== subcategory.keyName) return sc;
                            return {
                              ...sc, settingTypes: sc.settingTypes.map(st => {
                                if (st.keyName !== urgencyField.keyName) return st;
                                return {
                                  ...st,
                                  setting: {
                                    ...st.setting,
                                    specificType: FlyHourPriceCalculatorSettingTypeEnum.PERCENT
                                  }
                                }
                              })
                            }
                          })
                        }
                      })
                    }
                  }}>
                    <MarginBlockRadioCircle checked={urgencyType === FlyHourPriceCalculatorSettingTypeEnum.PERCENT}>
                      <MarginBlockRadioInner checked={urgencyType === FlyHourPriceCalculatorSettingTypeEnum.PERCENT} />
                    </MarginBlockRadioCircle>
                    <MarginBlockRadioLabel>{intl.formatMessage(FlyHourPriceCalculatorFieldMessages.percent)}</MarginBlockRadioLabel>
                  </MarginBlockRadioItem>
                  <MarginBlockRadioItem onClick={() => {
                    if (categorySetter) {
                      categorySetter(c => {
                        return {
                          ...c, subcategories: c.subcategories.map(sc => {
                            if (sc.keyName !== subcategory.keyName) return sc;
                            return {
                              ...sc, settingTypes: sc.settingTypes.map(st => {
                                if (st.keyName !== urgencyField.keyName) return st;
                                return {
                                  ...st,
                                  setting: {
                                    ...st.setting,
                                    specificType: FlyHourPriceCalculatorSettingTypeEnum.FLAT
                                  }
                                }
                              })
                            }
                          })
                        }
                      })
                    }
                  }}>
                    <MarginBlockRadioCircle checked={urgencyType === FlyHourPriceCalculatorSettingTypeEnum.FLAT}>
                      <MarginBlockRadioInner checked={urgencyType === FlyHourPriceCalculatorSettingTypeEnum.FLAT} />
                    </MarginBlockRadioCircle>
                    <MarginBlockRadioLabel>{intl.formatMessage(FlyHourPriceCalculatorFieldMessages.fix)}</MarginBlockRadioLabel>
                  </MarginBlockRadioItem>
                </MarginBlockRadioGroup>
                <MarginBlockFieldWrapper>
                  <MarginBlockFieldLabel>
                    {intl.formatMessage({id: "flyHourPriceCalculator.departureUrgency", defaultMessage: "Departure urgency margin, for requests within 24 hours"})}
                  </MarginBlockFieldLabel>
                  <MarginBlockInputWrapper>
              <CustomFieldInput
                      name={urgencyField.keyName}
              >
                <CustomInputNumber
                  controls={false}
                        placeholder="3"
                        addonAfter={urgencyType === FlyHourPriceCalculatorSettingTypeEnum.FLAT ? currency?.name : '%'}
                        style={{width: "100%", background: "#fff", height: "47px"}}
                        onChange={(value) => {
                          if (categorySetter) {
                            const numValue = typeof value === 'number' ? value : (value ? parseFloat(String(value)) : 0);
                            categorySetter(c => {
                              return {
                                ...c, subcategories: c.subcategories.map(sc => {
                                  if (sc.keyName !== subcategory.keyName) return sc;
                                  return {
                                    ...sc, settingTypes: sc.settingTypes.map(st => {
                                      if (st.keyName !== urgencyField.keyName) return st;
                                      return {
                                        ...st,
                                        setting: {
                                          ...st.setting,
                                          value: numValue
                                        }
                                      }
                                    })
                                  }
                                })
                              }
                            })
                          }
                        }}
                        value={urgencyField.setting.value}
                        precision={2}
                        parser={createCalculatorParser()}
                        onKeyDown={createCalculatorKeyDownHandler()}
                />
              </CustomFieldInput>
                  </MarginBlockInputWrapper>
                </MarginBlockFieldWrapper>
              </MarginBlockColumnUrgency>
            )}
          </MarginBlockContent>
          {urgencyField && (
            <div style={{display: 'flex', justifyContent: 'flex-end', width: '100%'}}>
              <MarginBlockFooterDescription>
                {intl.formatMessage({id: "flyHourPriceCalculator.urgencyDescription", defaultMessage: "Applies to the margin. The value may be negative and can include fractions."})}
              </MarginBlockFooterDescription>
            </div>
          )}
        </MarginBlockWrapper>
        </Col>
    );
  }

  // Рендер сезонного коэффициента с датами
  if (isSeasonalCoefficient) {
    // Проверяем, является ли это основным полем значения (без дат) или периодом с датами
    const isMainValueField = !settingType.setting.dateFrom && !settingType.setting.dateTo;
    const isPeriodField = !isMainValueField;
    
    // Если это период с датами, рендерим тег с датами
    if (isPeriodField) {
      const hasDates = settingType.setting.dateFrom || settingType.setting.dateTo;
      
      // Helper function to parse date string (format: YYYY-MM-DD)
      const parseDateString = (dateStr: string | undefined): { year: number, month: number, day: number } | null => {
        if (!dateStr) return null;
        const parts = dateStr.split('-');
        if (parts.length === 3) {
          // Format: YYYY-MM-DD
          return { year: parseInt(parts[0]), month: parseInt(parts[1]), day: parseInt(parts[2]) };
        }
        return null;
      };
      
      const formatDateRange = () => {
        let dateFromStr = '';
        let dateToStr = '';
        
        const dateFromParsed = parseDateString(settingType.setting.dateFrom);
        const dateToParsed = parseDateString(settingType.setting.dateTo);
        
        if (dateFromParsed) {
          const yearShort = String(dateFromParsed.year).slice(-2);
          dateFromStr = `${dateFromParsed.day}.${String(dateFromParsed.month).padStart(2, '0')}.${yearShort}`;
        }
        
        if (dateToParsed) {
          const yearShort = String(dateToParsed.year).slice(-2);
          dateToStr = `${dateToParsed.day}.${String(dateToParsed.month).padStart(2, '0')}.${yearShort}`;
        }
        
        if (dateFromStr && dateToStr) {
          return `${dateFromStr}–${dateToStr}`;
        } else if (dateFromStr) {
          return dateFromStr;
        } else if (dateToStr) {
          return dateToStr;
        }
        
        return intl.formatMessage({id: "flyHourPriceCalculator.selectDates", defaultMessage: "Select dates"});
      };

      return (
        <Col span={24} style={{marginBottom: 8}}>
          <div style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
            padding: '4px 12px',
            gap: 8,
            background: '#ECEDF0',
            borderRadius: 8,
            width: 'fit-content',
            minWidth: 160,
            height: 32,
          }}>
            {!isPeriodEditing && hasDates ? (
              <>
                <div style={{
                  fontSize: 12,
                  lineHeight: '24px',
                  color: '#000000',
                  flex: 1,
                  textAlign: 'center',
                }} onClick={() => setIsPeriodEditing(true)}>
                  {formatDateRange()}
                </div>
                <RemoveButton onClick={removeField} style={{marginLeft: 4}}>
                  <RemoveIcon style={{width: 16, height: 16}}/>
                </RemoveButton>
              </>
            ) : (
              <>
                <div style={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'center',
                  alignItems: 'center',
                  gap: 4,
                  flex: 1,
                }}>
                  <DatePicker
                    format="YYYY-MM-DD"
                    placeholder="YYYY-MM-DD"
                    size="small"
                    style={{width: 120}}
                    onChange={(date: Moment | null) => {
                      updateSettingField('dateFrom', date ? date.format('YYYY-MM-DD') : undefined);
                      if (date) setIsPeriodEditing(false);
                    }}
                    value={settingType.setting.dateFrom ? moment(settingType.setting.dateFrom, 'YYYY-MM-DD') : undefined}
                    open={isPeriodEditing || !hasDates}
                    onOpenChange={(open) => {
                      if (!open && hasDates) setIsPeriodEditing(false);
                      else setIsPeriodEditing(open);
                    }}
                  />
                  <span style={{fontSize: 12}}>-</span>
                  <DatePicker
                    format="YYYY-MM-DD"
                    placeholder="YYYY-MM-DD"
                    size="small"
                    style={{width: 120}}
                    onChange={(date: Moment | null) => {
                      updateSettingField('dateTo', date ? date.format('YYYY-MM-DD') : undefined);
                      if (date) setIsPeriodEditing(false);
                    }}
                    value={settingType.setting.dateTo ? moment(settingType.setting.dateTo, 'YYYY-MM-DD') : undefined}
                    open={isPeriodEditing || !hasDates}
                    onOpenChange={(open) => {
                      if (!open && hasDates) setIsPeriodEditing(false);
                      else setIsPeriodEditing(open);
                    }}
                  />
                </div>
                <RemoveButton onClick={removeField} style={{marginLeft: 4}}>
                  <RemoveIcon style={{width: 16, height: 16}}/>
                </RemoveButton>
              </>
            )}
          </div>
        </Col>
      );
    }
    
    // Если это основное поле значения, рендерим его с радиокнопками, title и инпутом
    return (
      <Col span={24}>
        <CoefficientInputWrapper>
          {radioButtons}
          <div style={{width: '100%', fontSize: 14, lineHeight: '120%', color: '#000000', marginBottom: 12}}>
            {settingType.label}
          </div>
          <CoefficientInputContainer isSeasonal={isSeasonalCoefficient}>
            <CoefficientInput
              type="number"
              placeholder={intl.formatMessage({id: "flyHourPriceCalculator.enterValue", defaultMessage: "Введите значение"})}
              value={settingType.setting.value || ''}
              onChange={(e) => handleCalculatorInputChange(e.target.value, (value) => updateSettingField('value', value))}
              onKeyDown={createCalculatorKeyDownHandler()}
              onPaste={createCalculatorPasteHandler((value) => updateSettingField('value', value))}
              disabled={isFieldDisabled}
            />
            {selectedType === FlyHourPriceCalculatorSettingTypeEnum.PERCENT ? (
              <CoefficientPercent>%</CoefficientPercent>
            ) : (
              <CoefficientPercent style={{color: '#6B6B6B'}}>{currency?.name || ''}</CoefficientPercent>
            )}
          </CoefficientInputContainer>
          <CoefficientDescription>
            {intl.formatMessage({id: "flyHourPriceCalculator.appliesOnlyToDatesBelow", defaultMessage: "это поле применяется только даты указанные ниже"})}
          </CoefficientDescription>
        </CoefficientInputWrapper>
      </Col>
    );
  }

  // Рендер поля топлива
  if (isFuelField) {
    return (
      <>
        <Col span={spanDependingOnSubcategory}>
          <CustomFieldInput
            label={<Tooltip title={intl.formatMessage({id: "flyHourPriceCalculator.fuelTooltip", defaultMessage: "Fuel cost per gallon × gallons per hour = fuel cost per hour"})}>
              <LabelWrapper>
                <div>{settingType.label}</div>
                {!settingType.isDefault && <RemoveButton onClick={removeField}><RemoveIcon/></RemoveButton>}
              </LabelWrapper>
            </Tooltip>}
            name={`${settingType.keyName}_fuelGallonsPerHour`}
            rules={[{min: 0, type: "number", message: intl.formatMessage(CommonFormMessages.ruleMustBePositive)}]}
          >
            <CustomInputNumber
              disabled={isFieldDisabled}
              controls={false}
              placeholder={intl.formatMessage(CommonFormMessages.commonPlaceholder)}
              addonAfter="gal/h"
              style={{width: "100%", background: "#fff"}}
              onChange={(value) => updateSettingField('fuelGallonsPerHour', value)}
              value={settingType.setting.fuelGallonsPerHour}
              precision={2}
              parser={createCalculatorParser()}
              onKeyDown={createCalculatorKeyDownHandler()}
            />
          </CustomFieldInput>
        </Col>
      </>
    );
  }

  // Рендер налогов (без toggle switch)
  if (isTaxesField) {
    return (
      <>
        <Col span={spanDependingOnSubcategory}>
          <CustomFieldInput
            label={<Tooltip title={settingType.label}>
              <div>{settingType.label}</div>
            </Tooltip>}
            name={settingType.keyName}
            rules={rules}
          >
            <CustomInputNumber
              disabled={isFieldDisabled}
              controls={false}
              placeholder={intl.formatMessage(CommonFormMessages.commonPlaceholder)}
              addonAfter="%"
              style={{width: "100%", background: "#fff"}}
              precision={2}
              parser={createCalculatorParser()}
              onKeyDown={createCalculatorKeyDownHandler()}
            />
          </CustomFieldInput>
        </Col>
      </>
    );
  }

  // Обычное поле
  // Для Fixed costs (CATEGORY_CONSTANT) не показываем валюту, так как она задается глобально
  const isConstantCategory = category.keyName === FlyHourPriceDefaultCategoryEnum.CATEGORY_CONSTANT;
  const addonAfterValue = isConstantCategory 
    ? (selectedType === FlyHourPriceCalculatorSettingTypeEnum.FLAT ? undefined : '%')
    : (selectedType === FlyHourPriceCalculatorSettingTypeEnum.FLAT ? currency?.name : '%');

  // Если это поле коэффициента с радио-кнопками, используем специальный layout
  if (isCoefficientField) {
    const isUrgentFlight = settingType.keyName === FlyHourPriceDefaultSettingTypeEnum.PARAMETER_COEFFICIENT_URGENT_FLIGHT;
    const span = isUrgentFlight ? 24 : spanDependingOnSubcategory;
    
    return (
      <Col span={span}>
        <div style={{display: 'flex', flexDirection: 'column', gap: 12}}>
          {radioButtons}
          <div style={{fontSize: 14, lineHeight: '120%', color: '#000000'}}>
            {isUrgentFlight 
              ? intl.formatMessage({id: "flyHourPriceCalculator.departureUrgency", defaultMessage: "Departure urgency margin, for requests within 24 hours"})
              : settingType.label}
          </div>
          <div>
            <CustomFieldInput
              name={settingType.keyName}
              rules={rules}
            >
              <CustomInputNumber
                disabled={isFieldDisabled}
                controls={false}
                placeholder={intl.formatMessage(CommonFormMessages.commonPlaceholder)}
                addonAfter={addonAfterValue}
                style={{width: "100%", background: "#fff"}}
                onChange={(value) => updateSettingField('value', value)}
                value={settingType.setting.value}
                precision={2}
                parser={createCalculatorParser()}
                onKeyDown={createCalculatorKeyDownHandler()}
              />
            </CustomFieldInput>
            {isUrgentFlight && (
              <div style={{
                color: '#757575',
                fontFamily: 'Inter, sans-serif',
                fontSize: '14px',
                fontWeight: 400,
                lineHeight: '120%',
                marginTop: '4px',
              }}>
                {intl.formatMessage({id: "flyHourPriceCalculator.urgentFlightDescription", defaultMessage: "Applies to the total sum of a flight. The value may be negative and can include fractions."})}
              </div>
            )}
          </div>
        </div>
      </Col>
    );
  }

  return (
    <>
      {radioButtons}
      <Col span={spanDependingOnSubcategory}>
        <CustomFieldInput
          label={<Tooltip title={settingType.label}>
            <LabelWrapper>
              <div>{settingType.label}</div>
              {!settingType.isDefault && <RemoveButton onClick={removeField}><RemoveIcon/></RemoveButton>}
            </LabelWrapper>
          </Tooltip>}
          name={settingType.keyName}
          rules={rules}
        >
          <CustomInputNumber
            disabled={isFieldDisabled}
            controls={false}
            placeholder={intl.formatMessage(CommonFormMessages.commonPlaceholder)}
            addonAfter={addonAfterValue}
            style={{width: "100%", background: "#fff"}}
            onChange={(value) => updateSettingField('value', value)}
            value={settingType.setting.value}
            precision={2}
            parser={createCalculatorParser()}
            onKeyDown={createCalculatorKeyDownHandler()}
          />
        </CustomFieldInput>
      </Col>
    </>
  );
};

